<div class="sectionbar">
  <app-settings-nav [page]="page"></app-settings-nav>
  <div class="sectionbar__actions"></div>
</div>
<div class="pages">
  @if (page == 'overblik') {
    <app-settings></app-settings>
  }
  @if (page == 'partnere') {
    <app-partner-list></app-partner-list>
  }
  @if (page == 'postnummer') {
    <app-postnummer-list></app-postnummer-list>
  }
  @if (page == 'installatoerer') {
    <app-installatoer-list></app-installatoer-list>
  }
  @if (page == 'henvisere') {
    <app-henvisere-list></app-henvisere-list>
  }
  @if (page == 'serviceabonnement') {
    <app-serviceabonnement-list></app-serviceabonnement-list>
  }
  @if (page == 'tilvalg') {
    <app-tilvalg-list></app-tilvalg-list>
  }
  @if (page == 'fabrikater') {
    <app-fabrikat-list></app-fabrikat-list>
  }
  @if (page == 'modeller') {
    <app-model-list></app-model-list>
  }
  @if (page == 'partnervarenr') {
    <app-partnervarenr-list></app-partnervarenr-list>
  }
  @if (page == 'areablacklist') {
    <app-area-blacklist></app-area-blacklist>
  }
  @if (page == 'rabatkampagner') {
    <app-rabatkampagner-list></app-rabatkampagner-list>
  }
  @if (page == 'partnerabonnementer') {
    <app-partnerabonnementer-list></app-partnerabonnementer-list>
  }
</div>
